import { createSelector } from "@reduxjs/toolkit";

/* ============================
   BASIC SELECTORS
============================ */

export const selectDoctorState = (state) => state.doctor;

export const selectDoctorUser = (state) => state.doctor.user;
export const selectDoctorEmail = (state) => state.doctor.email;

export const selectDoctorLoading = (state) => state.doctor.loading;
export const selectDoctorError = (state) => state.doctor.error;
export const selectDoctorMessage = (state) => state.doctor.message;

export const selectDoctorsList = (state) => state.doctor.doctors;
export const selectSelectedDoctor = (state) => state.doctor.selectedDoctor;

export const selectRegistrationForm = (state) => state.doctor.registrationForm;
export const selectRegistrationLoading = (state) =>
  state.doctor.registrationLoading;
export const selectRegistrationError = (state) =>
  state.doctor.registrationError;
export const selectRegistrationSuccess = (state) =>
  state.doctor.registrationSuccess;

export const selectCodeSent = (state) => state.doctor.codeSent;

/* ============================
   MEMOIZED SELECTORS (OPTIONAL)
============================ */

export const selectIsDoctorAuthenticated = createSelector(
  [selectDoctorUser],
  (user) => Boolean(user && user.id)
);

export const selectDoctorFullName = createSelector(
  [selectDoctorUser],
  (user) => user?.fullName || ""
);

export const selectDoctorProfile = createSelector(
  [selectDoctorUser],
  (user) => ({
    id: user?.id || user?._id,
    fullName: user?.fullName,
    email: user?.email,
    specialty: user?.specialty,
    phone: user?.phone,
    isVerified: user?.isVerified,
    experience: user?.experience,
    city: user?.city,
    country: user?.country,
  })
);

export const selectDoctorIsVerified = createSelector(
  [selectDoctorUser],
  (user) => Boolean(user?.isVerified)
);

export const selectDoctorAuthStatus = createSelector(
  [selectDoctorLoading, selectDoctorError, selectDoctorUser],
  (loading, error, user) => ({ loading, error, user })
);
